import periodicityReducer from './periodicity.slice'

export default periodicityReducer
